var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',[_c('template',{slot:"header"},[_vm._v(" Check In ")]),_c('Scan'),_c('Reservations')],2)}
var staticRenderFns = []

export { render, staticRenderFns }